<template>
    <component :is="card" :projectID="projectID" :categoryID="categoryID" :storyType="storyType" :isMarginless="isMarginless" :isRowLoading="isRowLoading" :isPinnableRow="isPinnableRow" :pinnedProjects="pinnedProjects" :size="size" :disableLink="disableLink" :displayType="displayType" :projectStatus="projectStatus"></component>
</template>

<script>
import Booth from './Types/Booth'
import Project from './Types/Project'
import NewProject from './Types/NewProject'
import Article from './Types/Article'
import Ajas from './Types/Ajas'
import Game from './Types/Game'
import WhitePaper from './Types/WhitePaper'
import Webinar from './Types/Webinar'
import Contributions from './Types/Contributions'
import cardSelector from './mixins/cardSelector'
import JudgeTeam from './Types/JudgeTeam'
import JudgeApplication from './Types/JudgeApplication'
import JudgeTeamProject from './Types/JudgeTeamProject'
export default {
  components: {
    Booth,
    Project,
    Game,
    Contributions,
    Article,
    Webinar,
    WhitePaper,
    JudgeTeam,
    JudgeApplication,
    Ajas,
    JudgeTeamProject,
    NewProject
  },
  props: {
    projectID: Number,
    categoryID: Number,
    storyType: Boolean,
    isMarginless: [Boolean, String],
    isRowLoading: Boolean,
    isPinnableRow: Boolean,
    pinnedProjects: Array,
    size: [String, Number],
    disableLink: Boolean,
    displayType: String,
    projectStatus: String,
    showBookmark: Boolean,
    judgingTeamID: Number,
    isGroupProject: Boolean
  },
  mixins: [cardSelector],
  computed: {
    project: function () {
      if (this.displayType === 'judgeTeam') {
        return this.projectID > 0 ? this.$store.getters.getJudgingTeam(this.projectID) : {}
      } else if (this.isGroupProject) {
        return this.projectID > 0 ? this.$store.getters.getGroupProjects[this.projectID] : {}
      }
      return this.projectID > 0 ? this.$store.getters.project(this.projectID) : {}
    }
  }
}
</script>
